import { api } from '@services';

import Document, { IDocument, IDocumentApiModel } from '@models/Document.model';

// interface INewContact {
//   manufacturerId?: string;
//   productIds?: string[];
//   haveOwnerStudio?: boolean;
//   label: string;
//   uri?: string;
//   file?: File;
//   description?: string;
// }

interface INewContact {
  manufacturerId?: string;

  productIds?: string[];
  haveOwnerStudio?: boolean;
  label: string;
  uri?: string;
  file?: File;
  description?: string;
  isGlobal?: boolean;
  // Alternative for insights, attaches without finding user or studio.
  studioId?: string;
  // Shortcut for single product
  productId?: string;
}

interface IManufacturerVariables {
  data: INewContact;
}

const addDocument = async ({
  data,
}: IManufacturerVariables): Promise<IDocument> => {
  const formData = new FormData();

  if (data.file) formData.append('file', data.file);
  if (data.uri) formData.append('uri', data.uri);
  if (data.description) formData.append('description', data.description);
  if (data.manufacturerId) {
    formData.append('manufacturerId', data.manufacturerId);
  }
  if (data.productIds) formData.append('productIds', data.productIds.join(','));
  // Backend does not have validation for boolean, hence the if
  if (data.haveOwnerStudio) {
    formData.append('haveOwnerStudio', String(Boolean(data.haveOwnerStudio))); // true
  }
  // Backend does not have validation for boolean, hence the if
  if (data.isGlobal) {
    formData.append('isGlobal', String(Boolean(data.isGlobal))); // true
  }

  formData.append('label', data.label);

  const { data: document } = await api.post<IDocumentApiModel>(
    `/documents/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return Document.fromApiModel(document);
};

export { addDocument };
